var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-row",on:{"click":_vm.goToArchives}},[_c('div',{staticClass:"nav-row-icon"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'trash']}})],1),_c('div',{staticClass:"nav-row-title"},[_vm._v(" "+_vm._s(_vm.$t('knowledge.archives.label'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }